export const getExpectedPhoneDigits = (countryCode: string) => {
  const digitCounts: { [key: string]: number } = {
    US: 10,
    CA: 10,
    MX: 10,
  };
  return digitCounts[countryCode] || 10;
};
